import { useQuery } from '@tanstack/react-query';
import { canUserPreviewDocument } from 'app/edozvola/document-preview/service/document-preview.service';

export const canUserPreviewDocumentQuery = (documentUuid: string, documentType: string, account: any, fromUrl, openedFromFileInspectionOrSubmissionOrNoticeBoard) => {
  return useQuery({
    queryKey: ['document-permission', { documentUuid: documentUuid, account: account }],
    queryFn: () => canUserPreviewDocument(documentUuid, documentType),
    enabled: openedFromFileInspectionOrSubmissionOrNoticeBoard ?
              !!documentUuid && !!account && !fromUrl :
              !!documentUuid && !!account  && account.firstName !== 'ROLE_NEPRIJAVLJENI' && !fromUrl,
  });
};
